import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFeatureEnabled, type FeatureFlag } from '../../config/featureFlags';

/**
 * Route-level gate for not-yet-complete product modules. When the feature is
 * OFF, the route quietly redirects to the dashboard instead of rendering an
 * unfinished/stub screen — so a reviewer never lands on a dead end, even via a
 * typed URL. Flip the flag in src/config/featureFlags.ts when the module ships.
 */
export const FeatureGate: React.FC<{ feature: FeatureFlag; children: React.ReactNode }> = ({
  feature,
  children,
}) => {
  if (!isFeatureEnabled(feature)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};
